var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9997 22.25V26C50.9997 37.7849 50.9997 43.6774 47.3372 47.3373C43.6797 50.9998 37.7848 50.9998 25.9998 50.9998C14.2149 50.9998 8.32246 50.9998 4.65998 47.3373C1 43.6799 1 37.7849 1 26C1 14.215 1 8.32258 4.65998 4.6601C8.32496 1.00012 14.2149 1.00012 25.9998 1.00012H29.7498",
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31L47 14.5C41 13.7 38.1667 7.83333 37.5 5L19.5 23L17 30.5L21 35L29 32L31 31Z",
    fill: "#014935",
    fillOpacity: 0.15,
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6296 4.63778L39.2521 3.01529C40.543 1.72469 42.2938 0.999766 44.1192 1C45.9446 1.00023 47.6952 1.72561 48.9858 3.01654C50.2764 4.30747 51.0013 6.05822 51.0011 7.88364C51.0008 9.70906 50.2755 11.4596 48.9845 12.7502L47.3595 14.3727C47.3595 14.3727 43.9146 14.1702 40.8746 11.1277C37.8321 8.08776 37.6296 4.64028 37.6296 4.64028L22.7172 19.5502C21.7072 20.5602 21.2022 21.0652 20.7672 21.6227C20.2547 22.2777 19.8172 22.9902 19.4572 23.7427C19.1547 24.3802 18.9297 25.0577 18.4772 26.4126L17.0297 30.7501M17.0297 30.7501L16.0947 33.5551C15.9848 33.8822 15.9682 34.2336 16.047 34.5696C16.1258 34.9056 16.2968 35.213 16.5407 35.4571C16.7846 35.7013 17.0918 35.8726 17.4277 35.9517C17.7636 36.0309 18.115 36.0147 18.4422 35.9051L21.2497 34.9701M17.0297 30.7501L21.2497 34.9701M47.362 14.3702L32.4496 29.2826C31.4396 30.2926 30.9346 30.7976 30.3771 31.2326C29.7201 31.745 29.0093 32.1842 28.2572 32.5426C27.6197 32.8451 26.9422 33.0701 25.5872 33.5226L21.2497 34.9701",
    stroke: "#014935",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.8ab89e8b19600bf10a4c919c00285a9b.svg";
export { ForwardRef as ReactComponent };